import { DEFAULT_SIGN_CODE, getPointSymbolLayerConfig } from "@l2r-front/l2r-map"

export const ENABLED_STATE = "1"
export const DISABLED_STATE = "0"

const NOT_SELECTED_SCALE = 0.8

export function getCatalogItemLayerStyle(signId = null, road = null) {
    return getPointSymbolLayerConfig({
        layout: {
            "symbol-sort-key": signId ? ["case",
                ["!=", ["typeof", signId], "string"],
                1,
                ["==", ["get", "uuid", ["properties"]], signId],
                10,
                1,
            ] : road ? ["case",
                ["!=", ["typeof", road], "string"],
                1,
                ["==", ["get", "road", ["get", "linearLocation"]], road],
                10,
                1,
            ] : 1,
            "icon-size": signId ? ["case",
                ["!=", ["typeof", signId], "string"],
                1,
                ["==", ["get", "uuid", ["properties"]], signId],
                1,
                NOT_SELECTED_SCALE,
            ] : road ? ["case",
                ["!=", ["typeof", road], "string"],
                1,
                ["==", ["get", "road", ["get", "linearLocation"]], road],
                1,
                NOT_SELECTED_SCALE,
            ] : 1,
            "icon-image":
                ["coalesce",
                    ["concat",
                        ["get", "globalIcon", ["properties"]],
                        "#",
                        ["get", "globalCondition", ["properties"]],
                        "#",
                        signId ? ["case",
                            ["!=", ["typeof", signId], "string"],
                            1,
                            ["==", ["get", "uuid", ["properties"]], signId],
                            1,
                            NOT_SELECTED_SCALE,
                        ] : !road ? [
                            "case",
                            ["==", ["get", "disabled", ["properties"]], true],
                            DISABLED_STATE,
                            ENABLED_STATE,
                        ] : ["case",
                            ["!=", ["typeof", road], "string"],
                            ENABLED_STATE,
                            ["==", ["get", "road", ["get", "linearLocation"]], road],
                            ENABLED_STATE,
                            DISABLED_STATE,
                        ],
                    ],
                    ["concat",
                        DEFAULT_SIGN_CODE,
                        "#",
                        ["get", "globalCondition", ["properties"]],
                        "#",
                        signId ? ["case",
                            ["!=", ["typeof", signId], "string"],
                            ENABLED_STATE,
                            ["==", ["get", "uuid", ["properties"]], signId],
                            ENABLED_STATE,
                            DISABLED_STATE]
                            : !road ? ENABLED_STATE : ["case",
                                ["!=", ["typeof", road], "string"],
                                ENABLED_STATE,
                                ["==", ["get", "road", ["get", "linearLocation"]], road],
                                ENABLED_STATE,
                                DISABLED_STATE,
                            ],
                    ],
                ],
        },
    })
}